import { gql } from '@apollo/react-hooks';

import {
  type FetchResult,
  type MutationFunctionOptions,
  useMutation,
} from '@apollo/client';

const REJECT_NONPROPOSED_APPLICATION = gql`
  mutation ($applicationIds: [String!]) {
    rejectNonProposedApplication(applicationIds: $applicationIds)
  }
`;

export const useRejectNonProposedApplication = (
  options?: MutationFunctionOptions,
): ((options?: MutationFunctionOptions) => Promise<FetchResult>) => {
  const [rejectNonproposed] = useMutation(REJECT_NONPROPOSED_APPLICATION, {
    ...options,
  });

  return rejectNonproposed;
};
